import { useMutation } from "react-query";
import { TextInput, Flex, PrimaryButton } from "@base-ui";
import ImageUploader from "./ImageUploader";
import { LoadingWithSpinner } from "@animation-ui";
import { uploadPrivateMedia } from "@media";
import { closePopup } from "utils/events";
import { debounce } from "utils/debounce";
import { useAuthContext } from "@authentication/context";
import { useErrorNotifications } from "@notifications/errorNotifications";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function UploadImageContent(props) {
  var selectImage = props.selectImage,
    setActiveImage = props.setActiveImage,
    activeImage = props.activeImage,
    description = props.description,
    setDescription = props.setDescription;
  var _useAuthContext = useAuthContext(),
    getUser = _useAuthContext.getUser;
  var authTicket = getUser().ticket;
  var _useMutation = useMutation(function () {
      return uploadPrivateMedia(activeImage, description, authTicket);
    }, {
      onSuccess: function onSuccess(data) {
        selectImage({
          alt: data[0].alt,
          src: data[0].url
        });
      }
    }),
    uploadMedia = _useMutation.mutate,
    error = _useMutation.error,
    uploading = _useMutation.isLoading;
  useErrorNotifications(error, ". Kunde inte ladda upp bilden.");
  var debouncedTextUpdate = debounce(setDescription, [500]);
  var disableUpload = !(activeImage && (description === null || description === void 0 ? void 0 : description.trim().length) >= 10);
  return /*#__PURE__*/_jsxs(Flex.Column, {
    id: "upload-image-panel",
    height: "calc(100% - 44px)",
    children: [/*#__PURE__*/_jsx(TextInput, {
      id: "add-image-description",
      value: description,
      autoFocus: true,
      placeholder: "Beskriv bilden...",
      label: "Fyll i en bildbeskrivning f\xF6r synskadade",
      mt: "15px",
      onChange: debouncedTextUpdate,
      border: "primary"
    }), /*#__PURE__*/_jsxs(Flex.Column, {
      flex: "1",
      mt: "20px",
      children: [/*#__PURE__*/_jsx(ImageUploader, {
        activeImage: activeImage,
        setActiveImage: setActiveImage
      }), /*#__PURE__*/_jsxs(Flex.Row, {
        justifyContent: "flex-end",
        mt: "20px",
        children: [/*#__PURE__*/_jsx(PrimaryButton, {
          id: "cancel-upload-image",
          onClick: closePopup,
          mr: "10px",
          width: "130px",
          children: "Avbryt"
        }), /*#__PURE__*/_jsx(PrimaryButton, {
          id: "upload-image",
          title: disableUpload ? "Du behöver välja en bild och fylla i en beskrivning" : undefined,
          disabled: disableUpload,
          width: "130px",
          onClick: uploadMedia,
          children: "V\xE4lj bild"
        }), uploading && /*#__PURE__*/_jsx(LoadingWithSpinner, {
          label: "Laddar upp bild...",
          width: "fit-content",
          ml: "15px"
        })]
      })]
    })]
  });
}